import { Component, computed, OnInit, Signal, ViewChild } from '@angular/core';

import { AuthService } from '@auth0/auth0-angular';
import { MyAuthService as MyAuthService } from './common/services/auth-service.service';
import { Router } from '@angular/router';
import { filter, take } from 'rxjs';
import { CollaboratorDto } from './models/collaborator.dto';
import { CollaboratorsService } from './common/services/collaborators.service';
import { CollaboratorStore } from './common/store/collaborator.store';
import { LanguageService } from './common/services/language.service';
import { WebSocketService } from './common/services/WebSocketService';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { WebSocketStore } from './common/store/web-socket-store.service';
import { LoaderService } from './common/services/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private auth: AuthService,
    private myAuthService: MyAuthService,
    private router: Router,
    private collaboratorStore: CollaboratorStore,
    private collaboratorService: CollaboratorsService,
    private languageService: LanguageService,
    private wsService: WebSocketService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    private websocketStore: WebSocketStore,
    private loaderService: LoaderService,
  ) {
  }

  ngOnInit(): void {
    this.wsService.connect((data: any) => { //deal of websocket
      if (data.status === 'FINISHED') {
        this.websocketStore.stop(); //to modify store and know that webssocket received a finished answer
        this.loaderService.hide(); //to stop the loader
        this.snackBar.open(this.translateService.instant(data.message), 'OK');
      }

      if (data.status === 'ERROR') {
        this.websocketStore.stop(); //to modify store and know that webssocket received a finished answer
        this.loaderService.hide(); //to stop the loader
        this.snackBar.open(this.translateService.instant(data.message), 'OK');
      }
    });

    this.languageService.init();

    // A post-login Action refuses the application AFTER Auth0 has authenticated the user, so the SSO
    // session survives the refusal. Left alone, every retry replays the same rejected identity and
    // the credentials form never comes back. Clearing the session is what lets another account in.
    this.myAuthService.errors().pipe(take(1)).subscribe(error => {
      if ((error as { error?: string }).error !== 'access_denied') {
        return;
      }
      this.myAuthService.logoutAfterDenial(error.message);
    });

    this.auth.isLoading$.pipe(
      filter(l => !l),
      take(1)
    ).subscribe({
      next: () => {
        this.auth.isAuthenticated$.pipe(take(1)).subscribe(isAuthenticated => {
          if (isAuthenticated) {
            this.getLoggedCollaborator();
          } else {
            this.router.navigate(['/login']);
          }
        });
      }
    });
  }

  getLoggedCollaborator() {
    this.collaboratorService.getLoggedCollaborator().subscribe((collab: CollaboratorDto.View) => {
      this.collaboratorStore.set(collab)
    })
  }
}
